import "./App.css";
import Clients from "./components/Clients";
import Header from "./components/Header";
import Layout from "./components/Layout";
import Main from "./components/Main";
import Services from "./components/Services";

function App() {
  return (
    <div className="App">
      <Layout>
        <Header />
        <Main />
        <Services />
        <Clients />
      </Layout>
    </div>
  );
}

export default App;
